import moment from "moment";
import React, { useEffect, useState } from "react";
import { Button } from "react-bootstrap";
import { format_number } from "../../../utilities/ext-function";

const ReportChatbotMostActiveUsers = ({ selectedData }) => {
  const [expandedRow, setExpandedRow] = useState(null);
  const [currentPage, setCurrentPage] = useState(1);
  const rowsPerPage = 10; // Ubah jumlah data per halaman sesuai kebutuhan

  // Hitung total halaman
  const totalPages = Math.ceil(selectedData?.length / rowsPerPage);

  // Ambil data berdasarkan halaman saat ini
  const currentData = selectedData?.slice(
    (currentPage - 1) * rowsPerPage,
    currentPage * rowsPerPage
  );

  return (
    <>
      <div className="table-responsive">
        <table className="table table-bordered table-custome">
          <thead>
            <tr className="text-white">
              <th className="text-center p-2">User Name</th>
              <th className="text-center p-2">Device / MSISDN</th>
              <th className="text-center p-2">Total Chat</th>
            </tr>
          </thead>
          <tbody>
            {currentData.length > 0 ? (
              currentData.map((row, index) => (
                <tr key={index}>
                  <td className="p-2">{row.user_name ? row.user_name : "-"}</td>
                  <td className="p-2">
                    {row.from_to_id ? row.from_to_id : "-"}
                  </td>
                  <td className="p-2 text-end">
                    {row.chat_count ? format_number(row.chat_count) : 0}
                  </td>
                </tr>
              ))
            ) : (
              <tr>
                <td colSpan="3" className="text-center p-2">
                  No Data
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </div>

      {/* Pagination */}
      {totalPages > 1 && (
        <div className="d-flex justify-content-between">
          <div>
            Page {currentPage} of {totalPages}
          </div>
          <div>
            <Button
              variant="primary"
              className="btn btn-sm me-2"
              disabled={currentPage === 1}
              onClick={() => setCurrentPage(currentPage - 1)}
            >
              Prev
            </Button>
            <Button
              variant="primary"
              className="btn btn-sm"
              disabled={currentPage === totalPages}
              onClick={() => setCurrentPage(currentPage + 1)}
            >
              Next
            </Button>
          </div>
        </div>
      )}
    </>
  );
};

export default ReportChatbotMostActiveUsers;
